module.exports = __webpack_public_path__ + "media/hk_3F RM4.ebd4a982.mp4";